/**
 * Created by B032151 on 10/24/2017.
 */
import _ from 'underscore';
import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';
import { restrictionRequestStore } from '../stores/restrictionRequest';
import { schematicStore } from '../stores/schematic';
import { schematicToolbarStore } from '../stores/schematicToolbar';
import { schematicUtil } from '../util/schematicUtil';
const { ActionTypes } = Constants;

//require the schematic components
var Schematic = require("tmds/Schematic");
var Point = require("tmds/geometry/Point");
var Layer = require("tmds/layers/Layer");
var SvgUtil = require('tmds/utils/svgUtils');

var Color = Constants.Colors;
//local variables
var selectionLayer,//layer to hold the guids being actively selected
    deselectionLayer,//layer to hold the guids being actively deselected
    currentRestrictionLayer,//layer to hold the guids that are part of the active restriction being submitted
    existingRestrictionLayer,//layer to hold guids for other active restrictions on the sub
    schematic,
    milePostLayer,
    hoverLayer,
    alphaTextLayer,//TMDS layer
    trackLayer,//TMDS layer
    signalLayer,//TMDS layer
    RrCrossingLayer,//TMDS layer
    switchLayer,//TMDS layer
    controlPointLayer,//TMDS layer
    trackLayerIds,//constant to hold all the track layers
    trackFields,//constant to hold all the track fields
    subdivision,
    subdivisionDetails,
    excludedGuids = [],
    hover = $('#guidHoverDiv'),
    guidSub = $('#guidSub'),
    guidId = $('#guidId'),
    guidMps = $('#guidMps'),
    guidTrack = $('#guidTrack'),
    currentMp = $('#currentMp'),
    contextMenu = $('#contextMenuDiv'),
    contextMenuMp = $('#mpValue'),
    contextMenuSfx = $('#sfxValue'),
    tmdsVersionSpan = $('#tmdsVersion'),
    ptcVersionSpan = $('#ptcVersion'),
    contextMenuFromMpDiv = document.getElementById('fromMpDiv'),
    contextMenuToMpDiv = document.getElementById('toMpDiv'),
    contextMenuCancelDiv = document.getElementById('ctxCancelDiv'),
    trackLayerGraph,
    subDetails = {
        REDROC: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "RED ROCK",
            "name": "REDROC",
            "usesGTB": true
        },
        FTWORT: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "FORT WORTH",
            "name": "FTWORT",
            "usesGTB": true
        },
        STJOSE: {
            "defaultDirection": "W",
            "defaultTimezone": "C",
            "fullName": "ST JOSEPH",
            "name": "STJOSE",
            "usesGTB": true
        },
        MYKAWA: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "MYKAWA",
            "name": "MYKAWA",
            "usesGTB": true
        },
        GALVES: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "GALVESTON",
            "name": "GALVES",
            "usesGTB": true
        },
        AVARD: {
            "defaultDirection": "W",
            "defaultTimezone": "C",
            "fullName": "Avard",
            "name": "AVARD",
            "usesGTB": true
        },
        BAYCIT: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "BAY CITY",
            "name": "BAYCIT",
            "usesGTB": true
        },
        BBRX: {
            "defaultDirection": "W",
            "defaultTimezone": "C",
            "fullName": "BBRX",
            "name": "BBRX",
            "usesGTB": true
        },
        CHICKA: {
            "defaultDirection": "W",
            "defaultTimezone": "C",
            "fullName": "CHICkASHA",
            "name": "CHICKA",
            "usesGTB": true
        },
        CONROE: {
            "defaultDirection": "W",
            "defaultTimezone": "C",
            "fullName": "CONROE",
            "name": "CONROE",
            "usesGTB": true
        },
        CREEK: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "CREEK",
            "name": "CREEK",
            "usesGTB": true
        },
        DFW: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "DFW",
            "name": "DFW",
            "usesGTB": true
        },
        HOUSTN: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "HOUSTON",
            "name": "HOUSTN",
            "usesGTB": true
        },
        LAFAYE: {
            "defaultDirection": "W",
            "defaultTimezone": "C",
            "fullName": "LAFAYETTE",
            "name": "LAFAYE",
            "usesGTB": true
        },
        LONGVI: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "LONGVIEW",
            "name": "LONGVI",
            "usesGTB": true
        },
        MADILL: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "MADILL",
            "name": "MADILL",
            "usesGTB": true
        },
        PLAINV: {
            "defaultDirection": "W",
            "defaultTimezone": "C",
            "fullName": "PLAINVIEW",
            "name": "PLAINV",
            "usesGTB": true
        },
        REDRIV: {
            "defaultDirection": "W",
            "defaultTimezone": "C",
            "fullName": "RED RIVER VALLEY",
            "name": "REDRIV",
            "usesGTB": true
        },
        SILSBE: {
            "defaultDirection": "S",
            "defaultTimezone": "C",
            "fullName": "SILSBEE",
            "name": "SILSBE",
            "usesGTB": true
        },
        SLATON: {
            "defaultDirection": "W",
            "defaultTimezone": "C",
            "fullName": "SLATON",
            "name": "SLATON",
            "usesGTB": true
        },
        SOONER: {
            "defaultDirection": "W",
            "defaultTimezone": "C",
            "fullName": "SOONER",
            "name": "SOONER",
            "usesGTB": true
        },
        VENUS: {
            "defaultDirection": "W",
            "defaultTimezone": "C",
            "fullName": "VENUS",
            "name": "VENUS",
            "usesGTB": true
        },
        WICFAL: {
            "defaultDirection": "W",
            "defaultTimezone": "C",
            "fullName": "WICHITA FALLS",
            "name": "WICFAL",
            "usesGTB": true
        },
    };

export const SchematicAPI = {
    /**
     * Setup function for schematic
     */
    initialize: function () {

        /**
         * create schematic instance
         */
        $('#mainSchematic').show();
        schematic = new Schematic("mainSchematic",
            {
                env: window.gritConfig.gisEnvironment,
                useTrackAltName: true,
                renderMode: "GRIT"
            });

        //Subscribe to the Schematic store to get changes from Flux cycle
        schematicStore.subscribe(this._onChange);

        //get the schematic constants for use
        trackLayerIds = Schematic.tmdsLayerIds();
        trackFields = Schematic.trackKeyFields();

        //get a reference to the track layer for later
        trackLayer = schematic.getLayer(trackLayerIds.TMDS_TRACK);
        signalLayer = schematic.getLayer(trackLayerIds.TMDS_SIGNAL);
        RrCrossingLayer = schematic.getLayer(trackLayerIds.TMDS_INTERLOCKER);
        switchLayer = schematic.getLayer(trackLayerIds.TMDS_SWITCH);
        controlPointLayer = schematic.getLayer(trackLayerIds.TMDS_CONTROLPOINT);
        alphaTextLayer = schematic.getLayer(trackLayerIds.TMDS_ALPHATEXT);

        //layers for holding guids
        existingRestrictionLayer = new Layer([], { geometryType: "Line" }, { id: "existingRestrictionLayer" });
        schematic.addLayer(existingRestrictionLayer);

        currentRestrictionLayer = new Layer([], { geometryType: "Line" }, { id: "currentRestrictionLayer" });
        schematic.addLayer(currentRestrictionLayer);

        selectionLayer = new Layer([], { geometryType: "Line" }, { id: "selectionLayer" });
        schematic.addLayer(selectionLayer);

        deselectionLayer = new Layer([], { geometryType: "Line" }, { id: "deselectionLayer" });
        schematic.addLayer(deselectionLayer);

        hoverLayer = new Layer([], { geometryType: "Line" }, { id: "hoverLayer" });
        schematic.addLayer(hoverLayer);

        milePostLayer = new Layer([], {
            geometryType: "Point",
            geometryInfo: {
                x: "x",
                y: "y"
            }
        }, {
            id: "lyrPoint"
        });

        schematic.addLayer(milePostLayer);
        registerHandlers();
    },

    toggleSchematicCollapse: function (tabsCollapsed) {
        console.log('schematic collapsing, tabsCollapsed: ', tabsCollapsed);
        if (tabsCollapsed) {
            //modify the schematic DIV to be full because the tabs are collapsed (oppposite of the tab)
            $('#mainSchematic').removeClass();
            $('#mainSchematic').addClass('schematicFull');

            schematic.resize();

        }
        else {
            //modify the schematic DIV to be collapsed because the tabs are open (oppposite of the tab)
            $('#mainSchematic').removeClass();
            $('#mainSchematic').addClass('schematicCollapsed');
            schematic.resize();
        }
    },

    _onChange: function () {
        //reset the schematic
        resetSchematicNoPrompt();

        var result = schematicStore.getServerGuidCalculationResult();
        var selectedTracks = schematicStore.getSchematicSelectedTracks();
        var form = schematicStore.getForm();
        var fromMp = schematicStore.getFromMp();
        var fromSfx = schematicStore.getFromMpSuffix();
        var toMp = schematicStore.getToMp();
        var toSfx = schematicStore.getToMpSuffix();
        var useFormGuids = schematicStore.getUseFormGuids();

        if (form && fromMp == null) {
            fromMp = form.workStartMp;
            fromSfx = form.workStartMpSuffix;
        }

        if (form && toMp == null) {
            toMp = form.workEndMp;
            toSfx = form.workEndMpSuffix;
        }

        if (result != null) {
            if (useFormGuids) {
                console.log("Using Guids from form");
                excludedGuids = form.excludedGuids || [];
                var restrictionStartMp = form.workStartMp;
                var restrictionEndMp = form.workEndMp;
                if (form.trackGuids.length === 0) {
                    console.log('No guids included in restrictions');
                }
                else {
                    console.log('included guids', form.trackGuids)
                }

                if (excludedGuids.length === 0) {
                    console.log('no excluded guids found');
                }
                else {
                    console.log('excluded guids', form.excludedGuids)
                }

                //highlight all the guids except the excluded guids
                var selectedIds = form.trackGuids.map(function (g) {
                    return g[trackFields.TRACK_GUID]
                });

                var selectedGuids = trackLayer.elements.filter(function (g) {
                    return selectedIds.indexOf(g.attributes[trackFields.TRACK_GUID]) > -1
                });

                milePostLayer.clear();
                var partialSelectedGuids = selectedGuids.map(function (selectedGuid) {
                    //apply the MPs from the restriction.trackGuids to the selectedGuids
                    var attr = selectedGuid.attributes,
                        id = attr[trackFields.TRACK_GUID],
                        beginMp = attr[trackFields.TRACK_BMP],
                        endMp = attr[trackFields.TRACK_EMP];
                    var restrictionPartialGuid = _.findWhere(form.trackGuids, { tmdsUid: id });
                    if (restrictionPartialGuid) {
                        if (restrictionPartialGuid.beginMp != beginMp ||
                            restrictionPartialGuid.endMp != endMp) {
                            //the guids have different length, so make the selected guid a partial guid
                            var partialGuid = schematicUtil.getPartialHostGuid(selectedGuid, restrictionPartialGuid.beginMp, restrictionPartialGuid.endMp, trackFields);

                            var mpMarkers = schematicUtil.getMilepostMarkersOnHostGuid(partialGuid, restrictionStartMp, form.workStartMpSuffix, restrictionEndMp, form.workEndMpSuffix, trackFields, result.leftMp, result.leftSfx);

                            //If there are milepost markers add them to the milepost layer
                            if (mpMarkers != null) {
                                mpMarkers.map(function (marker) { milePostLayer.addElement(marker) });
                            }
                            return partialGuid;
                        }
                        else {
                            var isLeft;
                            var mp;
                            var mpPointOnGuid;
                            var sfx;
                            //If it is not a partial need to check if the mp land on the end of the GUID
                            if (restrictionPartialGuid.beginMp == restrictionStartMp) {
                                //Create Mp Marker
                                mp = restrictionPartialGuid.beginMp;
                                mpPointOnGuid = interpolateMpOnGuid(trackLayerGraph[restrictionPartialGuid.tmdsUid], restrictionPartialGuid.beginMp, trackFields);
                                sfx = restrictionPartialGuid.mpSuffix;
                                isLeft = !(restrictionPartialGuid.beginMp > restrictionPartialGuid.endMp);

                                var elem = schematicUtil.createMilepostMarker(mpPointOnGuid, mp, sfx, isLeft);

                                milePostLayer.addElement(elem);
                            }
                            else if (restrictionPartialGuid.beginMp == restrictionEndMp) {
                                //Create Mp Marker
                                mp = restrictionPartialGuid.beginMp;
                                mpPointOnGuid = interpolateMpOnGuid(trackLayerGraph[restrictionPartialGuid.tmdsUid], restrictionPartialGuid.beginMp, trackFields);
                                sfx = restrictionPartialGuid.mpSuffix;
                                isLeft = restrictionPartialGuid.beginMp > restrictionPartialGuid.endMp;

                                var elem = schematicUtil.createMilepostMarker(mpPointOnGuid, mp, sfx, isLeft);

                                milePostLayer.addElement(elem);
                            }
                            else if (restrictionPartialGuid.endMp == restrictionEndMp) {
                                //Create Mp Marker
                                mp = restrictionPartialGuid.endMp;
                                mpPointOnGuid = interpolateMpOnGuid(trackLayerGraph[restrictionPartialGuid.tmdsUid], restrictionPartialGuid.endMp, trackFields);
                                sfx = restrictionPartialGuid.mpSuffix;
                                isLeft = restrictionPartialGuid.beginMp > restrictionPartialGuid.endMp;

                                var elem = schematicUtil.createMilepostMarker(mpPointOnGuid, mp, sfx, isLeft);

                                milePostLayer.addElement(elem);
                            }
                            else if (restrictionPartialGuid.endMp == restrictionStartMp) {
                                //Create Mp Marker
                                mp = restrictionPartialGuid.endMp;
                                mpPointOnGuid = interpolateMpOnGuid(trackLayerGraph[restrictionPartialGuid.tmdsUid], restrictionPartialGuid.endMp, trackFields);
                                sfx = restrictionPartialGuid.mpSuffix;
                                isLeft = !(restrictionPartialGuid.beginMp > restrictionPartialGuid.endMp);

                                var elem = schematicUtil.createMilepostMarker(mpPointOnGuid, mp, sfx, isLeft);

                                milePostLayer.addElement(elem);
                            }
                        }
                        //it is not partial, so just return it
                        return selectedGuid;
                    }
                    else {
                        console.log('cannot find guid')
                    }
                });

                setSelectedGuids(partialSelectedGuids);
                highlightSelectedGuids(true);

                if (schematicToolbarStore.canAutoCenterAndZoom()) {
                    centerAndZoom();
                }
            }
            else {
                console.log("Using server calculated Guids");
                //If any tracks are selected, then start the highlighting logic
                if (selectedTracks.length > 0) {
                    var selectedGuids = [];
                    selectedTracks.map(function (name) {
                        //find the track we want and get its guids
                        var trackDefinition = _.findWhere(result.trackDefinitions, { name: name });
                        if (trackDefinition != null) {
                            var innerGuids = trackDefinition.innerGuids;
                            var hostGuids = trackDefinition.hostGuids;
                        }

                        if (innerGuids != null) {
                            //Add the inner guids to the selection
                            // innerGuids.map(function (innerGuidId) {
                            //     selectedGuids.push(trackLayerGraph[innerGuidId]);
                            // });

                            innerGuids.map(function (guid) {
                                selectedGuids.push(schematicUtil.getPartialGuid(trackLayerGraph[guid.tmdsUid], guid.beginMp, guid.endMp, trackFields));
                            })
                        }
                        else
                            console.log("No inner guids");

                        if (hostGuids != null) {
                            //Transform the host guids into partial and add them to the selection
                            hostGuids.map(function (hostGuid) {
                                var partialGuid = schematicUtil.getPartialHostGuid(trackLayerGraph[hostGuid.tmdsUid], hostGuid.beginMp, hostGuid.endMp, trackFields);
                                //Add them to selection
                                selectedGuids.push(partialGuid);
                                //Add milepost markers
                                var mpMarkers = schematicUtil.getMilepostMarkersOnHostGuid(partialGuid, fromMp, fromSfx, toMp, toSfx, trackFields, result.leftMp, result.leftSfx);

                                //If there are milepost markers add them to the milepost layer
                                if (mpMarkers != null) {
                                    mpMarkers.map(function (marker) {
                                        milePostLayer.addElement(marker)
                                    });
                                }
                            });
                        }
                        else
                            console.log("No host guids")
                    });
                    setSelectedGuids(selectedGuids);
                    console.log("Selected Guids; ", selectedGuids);
                    highlightSelectedGuids(true);

                    if (schematicToolbarStore.canAutoCenterAndZoom()) {
                        centerAndZoom();
                    }
                }
            }

            setTimeout(function () {
                dispatcher.dispatch({
                    type: ActionTypes.SCHEMATIC_UPDATE_COMPLETE,
                    tracks: selectedTracks,
                    guids: currentRestrictionLayer.elements,//the selected guids
                    excludedGuids: excludedGuids//the guids explicitly excluded
                });
            }, 1);
        }
    },

    /**
     * Sets the subdivision of the schematic
     * @param sub
     */
    setSubdivision: function (sub) {
        return new Promise(function (resolve, reject) {
            selectionLayer.clear();
            deselectionLayer.clear();
            milePostLayer.clear();
            currentRestrictionLayer.clear();
            existingRestrictionLayer.clear();
            var promise = schematic.setSubdivision(sub);

            promise.done(function () {
                dispatcher.dispatch({
                    type: ActionTypes.SCHEMATIC_SUB_LOADED
                });
                resolve('Subdivision Set to ' + sub);
            }).fail(function (response) {
                console.log(response);
                if (response.indexOf("No schematic") > -1) {
                    dispatcher.dispatch({
                        type: ActionTypes.SCHEMATIC_SUB_FAILED_LOAD,
                        message: [{
                            field: 'subdiv',
                            message: response,
                            type: 'warning'
                        }]
                    });

                    reject('Load Warning');
                } else {
                    dispatcher.dispatch({
                        type: ActionTypes.SCHEMATIC_SUB_FAILED_LOAD,
                        message: [{ field: 'subdiv', message: response + ". Please check your network connection", type: 'error' }]
                    });

                    reject('Load Error');
                }
            });

            subdivision = sub;
        });
    },

    /**
     * Method called to pass in the subdivision details after they have been loaded from the server
     */
    subdivisionDetailsLoaded: function (details) {

        subdivisionDetails = details;

        console.log('subdivision details saved for schematic', JSON.stringify(subdivisionDetails));
    },

    cleanup: function () {
        $('#mainSchematic').hide();
    },

    /**
     * resets the schematic without prompting
     */
    resetSchematicNoPrompt: resetSchematicNoPrompt,

    /**
     * Shows all the layers
     */
    showAllLayers: function () {

        //custom layers
        milePostLayer.show();
        selectionLayer.show();
        deselectionLayer.show();
        currentRestrictionLayer.show();
        existingRestrictionLayer.show();

        //TMDS layers
        trackLayer.show();
        signalLayer.show();
        RrCrossingLayer.show();
        switchLayer.show();
        controlPointLayer.show();
        alphaTextLayer.show();
        dispatcher.dispatch({
            type: ActionTypes.SHOW_SCHEMATIC
        })
    },

    /**
     * Centers and zooms the schematic on the selected guids and MPs
     */
    centerAndZoom: centerAndZoom,

    /**
     * Sets the schematic to navigate mode
     */
    setNavigate: setNavigate,

    /**
     * Sets the schematic to exclusion mode
     */
    setExclude: setExclude,

    clearSubdivision: function () {
        selectionLayer.clear();
        deselectionLayer.clear();
        currentRestrictionLayer.clear();
        existingRestrictionLayer.clear();
        this.hideAllLayers();
    },

    /**
     * Hides all the layers
     */
    hideAllLayers: function () {

        //my layers to hide
        milePostLayer.hide();
        selectionLayer.hide();
        deselectionLayer.hide();
        currentRestrictionLayer.hide();
        existingRestrictionLayer.hide();

        //TMDS layers to hide
        trackLayer.hide();
        signalLayer.hide();
        RrCrossingLayer.hide();
        switchLayer.hide();
        controlPointLayer.hide();
        alphaTextLayer.hide();
        dispatcher.dispatch({
            type: ActionTypes.HIDE_SCHEMATIC
        })
    },

    getSubDetails(name, subData) {
        var details = subDetails[name];
        var data = subData;

        if (details == null) {
            console.log("Do not have hard coded sub details for " + name);
        }
        else if (subData == null || _.isEmpty(subData)) {
            console.log("Did not get sub data for " + name + " using GRIT data: " + JSON.stringify(details));
            data = details;
        }
        else {
            if (subData.defaultTimezone == null || subData.defaultTimezone == "") {
                console.log("Setting time zone to " + details.defaultTimezone + " for subdivision " + name);
                data.defaultTimezone = details.defaultTimezone;
            }
            if (subData.defaultDirection == null || subData.defaultDirection == "") {
                console.log("Setting direction to " + details.defaultDirection + " for subdivision " + name);
                data.defaultDirection = details.defaultDirection;
            }
        }

        return data;
    },

    useAlternateTrackName(should) {
        console.log("should use alternate track names: ", should);
        schematic.setUseTrackAltName(should);
    },
};

/**
 * registers all the click and key up/down handlers for the layers
 * @param that
 */
function registerHandlers() {

    schematic.on("load", schematicOnLoad);
    schematic.on('click', schematicOnClick);

    trackLayer.on("click", trackLayerOnClick);
    trackLayer.on("mouseover", layerMouseEnter);
    trackLayer.on("mousemove", layerMouseMove);
    trackLayer.on('mouseout', layerMouseOut);

    currentRestrictionLayer.on("click", restrictionLayerOnClick);
    currentRestrictionLayer.on("mouseover", layerMouseEnter);
    currentRestrictionLayer.on("mousemove", layerMouseMove);
    currentRestrictionLayer.on('mouseout', layerMouseOut);

    $(document).keydown(documentKeyDown);
    $(document).keyup(documentKeyUp);

    contextMenuFromMpDiv.addEventListener("click", contextOnClick);
    contextMenuToMpDiv.addEventListener("click", contextOnClick);
    contextMenuCancelDiv.addEventListener("click", contextOnClick)

}

/**
 * The schematic on load function
 */
function schematicOnLoad(e) {
    console.log('Successfully loaded subdivision into schematic', e);
    trackLayerGraph = {};
    //builds an object where you can deference via the guid to directly get that element.
    //no more searching through lists
    trackLayer.elements.forEach(function (elem) {
        trackLayerGraph[elem.attributes[trackFields.TRACK_GUID]] = elem
    });

    if (subdivision === "FTWORT") {
        var badGuids = trackLayer.elements.filter(function (elem) {
            return elem.attributes[trackFields.TRACK_NAME] === "NOTHING" && elem.attributes['renderType'] === "ZeroMP" && elem.attributes['authorityType'] === "CTC";
        });
        var badAttributes = _.pluck(badGuids, 'attributes');

        var badTerritories = _.pluck(badAttributes, 'territoryAssignment');

        badTerritories = _.uniq(badTerritories);

        var badTrack = trackLayer.elements.filter(function (trackElem) {
            return badTerritories.indexOf(trackElem.attributes['territoryAssignment']) > -1;
        });

        var badSignals = signalLayer.elements.filter(function (signalElem) {
            return badTerritories.indexOf(signalElem.attributes['territoryAssignment']) > -1;
        });

        var badSwitches = switchLayer.elements.filter(function (switchElem) {
            return badTerritories.indexOf(switchElem.attributes['territoryAssignment']) > -1;
        });

        var badAlphaText = alphaTextLayer.elements.filter(function (textElem) {
            return badTerritories.indexOf(textElem.attributes['territoryAssignment']) > -1;
        });

        var badControlPoints = controlPointLayer.elements.filter(function (controlElem) {
            return badTerritories.indexOf(controlElem.attributes['territoryAssignment']) > -1;
        });

        badTrack.forEach(function (elem) {
            trackLayer.removeElement(elem);
        });

        badControlPoints.forEach(function (elem) {
            controlPointLayer.removeElement(elem);
        });

        badAlphaText.forEach(function (elem) {
            alphaTextLayer.removeElement(elem);
        });

        badSignals.forEach(function (elem) {
            signalLayer.removeElement(elem);
        });

        badSwitches.forEach(function (elem) {
            switchLayer.removeElement(elem);
        });

        badGuids.forEach(function (elem) {
            trackLayer.removeElement(elem);
        });
    }

    centerAndZoom();

    dispatcher.dispatch({
        type: ActionTypes.RELOAD_ENTERED_TEXT
    });
}

function schematicOnClick(e) {
    contextMenu.removeClass();
    contextMenu.addClass('guidHoverHide');
}

/**
 * Moves a single guid from the track layer to the selection layer and starts the update cycle
 * @param e
 */
function trackLayerOnClick(e) {
    //this highlights the selected guid for viewing before applying to the restriction layer
    var attrs = e.svgElement.attributes;
    if (schematicIsReadOnly()) {

    }
    else if (schematicToolbarStore.isExcluding()) {
        e.svgElement.symbol.setColor(Color.blue);
        selectionLayer.clear();

        var guidSub = attrs[trackFields.TRACK_SUBDIV],
            renderType = attrs['renderType'];

        if (guidSub === subdivision && renderType === "Normal") {
            selectionLayer.addElement(e.svgElement);
            //TODO: Fix This
            //determineSchematicAction(ActionTypes.ADD_GUID);
        }
    }
    else {
        nonExcludingClickHandler(e);
    }
    console.log('Information for GUID ', attrs[trackFields.TRACK_GUID], attrs);
}

/**
 * Pops up an information box on the guid you are hovering over
 * @param e
 */
function layerMouseEnter(e) {
    var attr = e.svgElement.attributes,
        sub = attr[trackFields.TRACK_SUBDIV];

    hover.removeClass();
    hover.css({ top: e.pageY - hover.height() - 10, left: e.pageX });
    hover.addClass('guidHoverShow');

    var attr = e.svgElement.attributes,
        guid = attr[trackFields.TRACK_GUID],
        bmp = attr[trackFields.TRACK_BMP],
        sfx = attr[trackFields.TRACK_MPSUF],
        emp = attr[trackFields.TRACK_EMP],
        name = attr[trackFields.TRACK_NAME];

    if (bmp % 1 === 0)                         //If the milepost is an integer add the .0 to the end of the number
    {
        var bLength = bmp.toString().length;
        bmp = bmp.toPrecision(bLength + 1);
    }

    if (emp % 1 === 0) {
        var eLength = emp.toString().length;
        emp = emp.toPrecision(eLength + 1);
    }

    if (sub !== subdivision) {
        guidSub.text('Sub: ' + sub);
    }
    else {
        guidSub.text('');
    }
    guidId.text('Id: ' + guid);
    guidMps.text('Bmp: ' + bmp + (sfx ? sfx : '') + ' Emp: ' + emp + (sfx ? sfx : ''));
    guidTrack.text('Track: ' + name);


    var mp = interpolatePointOnGuid(e.svgElement, { x: e.pageX, y: e.pageY });

    var mpText = 'Cursor MP: ' + (mp ? mp.toFixed(3) : "NA");
    var sfxText = (sfx ? " " + sfx : "");

    currentMp.text(mpText + sfxText);

    e.svgElement.symbol.setColor(Color.purple);
}

function layerMouseMove(e) {
    var attr = e.svgElement.attributes,
        sub = attr[trackFields.TRACK_SUBDIV];

    hover.removeClass();
    hover.css({ top: e.pageY - hover.height() - 10, left: e.pageX });
    hover.addClass('guidHoverShow');

    var attr = e.svgElement.attributes,
        guid = attr[trackFields.TRACK_GUID],
        bmp = attr[trackFields.TRACK_BMP],
        sfx = attr[trackFields.TRACK_MPSUF],
        emp = attr[trackFields.TRACK_EMP],
        name = attr[trackFields.TRACK_NAME],
        ptcVersion = attr[trackFields.PTC_VERSION],
        tmdsVersion = attr[trackFields.TMDS_VERSION];
    if (bmp % 1 === 0)                         //If the milepost is an integer add the .0 to the end of the number
    {
        var bLength = bmp.toString().length;
        bmp = bmp.toPrecision(bLength + 1);
    }

    if (emp % 1 === 0) {
        var eLength = emp.toString().length;
        emp = emp.toPrecision(eLength + 1);
    }

    if (sub != subdivision) {
        guidSub.text('Sub: ' + sub);
    }
    else {
        guidSub.text('');
    }
    guidId.text('Id: ' + guid);
    guidMps.text('Bmp: ' + bmp + (sfx ? sfx : '') + ' Emp: ' + emp + (sfx ? sfx : ''));
    guidTrack.text('Track: ' + name);
    ptcVersionSpan.text('PTC Version: ' + ptcVersion);
    tmdsVersionSpan.text('TMDS Version: ' + tmdsVersion);
    var mp = interpolatePointOnGuid(e.svgElement, { x: e.pageX, y: e.pageY });

    var mpText = 'Cursor MP: ' + (mp ? mp.toFixed(3) : "NA");
    var sfxText = (sfx ? " " + sfx : "");

    currentMp.text(mpText + sfxText);

}

/**
 * Hides the hover box when leaving the guid
 * @param e
 */
function layerMouseOut(e) {

    //if (sub === subdivision){
    hover.removeClass();
    hover.addClass('guidHoverHide');

    e.svgElement.symbol.setColor(Color.black);
}

/**
 * Moves a single guid to the deselection layer and starts the update cycle
 * @param e
 */
function restrictionLayerOnClick(e) {

    var attrs = e.svgElement.attributes;

    //only remove guids if we're in excluding mode
    if (schematicIsReadOnly()) {

    }
    else if (schematicToolbarStore.isExcluding()) {
        //this highlights the selected guid for viewing before removing from the restriction layer
        e.svgElement.symbol.setColor(Color.red);
        //move the clicked element to the deselectionLayer
        deselectionLayer.addElement(e.svgElement);
        //TODO: Fix This
        //determineSchematicAction(ActionTypes.REMOVE_GUID);
    }
    else {
        nonExcludingClickHandler(e);
    }
    console.log('Information for GUID ', attrs[trackFields.TRACK_GUID], attrs);
}

/**
 * event handler for docuemnt key down
 * @param e
 */
function documentKeyDown(e) {
    if (schematicToolbarStore.isNavigating()) {//if navigating...either button press changes state
        //if (e.altKey && e.ctrlKey){
        //setDeselect();
        //}
        //else
        if (e.ctrlKey) {
            //setSelect();
            setExclude();
        }
    }
}

/**
 * event handler for document key up
 * @param e
 */
function documentKeyUp(e) {
    switch (e.keyCode) {
        case 27://esc key
            selectionLayer.clear();
            return;
    }
    ;

    if (schematicToolbarStore.isNavigating()) {//navigating, ignore key up
        return;
    }
    else {//selecting or deselecting
        if (e.ctrlKey && !e.altKey) {
            //setSelect();
            setExclude();
        }
        else {
            setNavigate();
        }
    }
}

function contextOnClick(e) {
    var field;
    console.log(e);
    this.parentElement.className = "guidHoverHide";

    //just need to figure out what the box will say, parse out the field and value....
    switch (this.id) {
        case "fromMpDiv":
            field = "workStartMp";
            break;
        case "toMpDiv":
            field = "workEndMp";
            break;
        case "ctxCancelDiv":
            //no op, just close the box (done above)
            return;
    }

    dispatcher.dispatch({
        type: ActionTypes.SCHEMATIC_CLICKED,
        mp: contextMenuMp.text(),
        sfx: contextMenuSfx.text(),
        field: field
    });
    //TODO: Change this
    //determineSchematicAction(ActionTypes.FORM_UPDATED);

}

/**
 * Sets the schematic to mass select mode
 */
function setExclude() {
    dispatcher.dispatch({
        type: ActionTypes.SET_EXCLUDE
    });
}

/**
 * Sets the schematic to navigate mode
 */
function setNavigate() {
    dispatcher.dispatch({
        type: ActionTypes.SET_NAVIGATE
    });
}

function schematicIsReadOnly() {
    //TODO: Change this to passed in instead of store
    var ro = restrictionRequestStore.getReadOnly() || restrictionRequestStore.getPartialReadOnly();

    console.log('Schematic readonly = ', ro);
    return ro
}

function nonExcludingClickHandler(e) {
    var bothMps = true;

    var attr = e.svgElement.attributes,
        sfx = attr[trackFields.TRACK_MPSUF],
        subName = attr[trackFields.TRACK_SUBDIV];

    var clickMp = interpolatePointOnGuid(e.svgElement, { x: e.pageX, y: e.pageY });
    if (subName === subdivision && clickMp && !attr.disableForRestrictions && !attr.uidNotDisplayedInGRITView && !attr.territoryNotDisplayedInGRITView) {
        clickMp = clickMp.toFixed(1);

        bothMps = restrictionRequestStore.bothMps();

        if (bothMps) {
            //hide the MP window
            hover.removeClass();
            hover.addClass('guidHoverHide');
            //show context menu
            contextMenuMp.text(clickMp);
            contextMenuSfx.text(sfx);
            //make the menu visible
            contextMenu.removeClass();
            contextMenu.css({ top: e.pageY - hover.height() - 10, left: e.pageX });
            contextMenu.addClass('guidHoverShow');
            //register handlers for the spans
        }
        else {//click and let the store figure it out
            dispatcher.dispatch({
                type: ActionTypes.SCHEMATIC_CLICKED,
                mp: clickMp,
                sfx: sfx
            });
            //TODO: Fix this
            //determineSchematicAction(ActionTypes.FORM_UPDATED);
        }
    }
}

function interpolatePointOnGuid(elem, point) {
    var attrs = elem.attributes,
        trkLX = attrs[trackFields.TRACK_LX],
        trkLY = attrs[trackFields.TRACK_LY],
        trkRX = attrs[trackFields.TRACK_RX],
        trkRY = attrs[trackFields.TRACK_RY],
        trkBMP = attrs[trackFields.TRACK_BMP],
        trkEMP = attrs[trackFields.TRACK_EMP];

    point = schematic.toGeomPoint(point.x, point.y);

    var deltaMile = Math.abs(trkBMP - trkEMP);
    var guidGeometryLength = lineDistance({ x: trkLX, y: trkLY }, { x: trkRX, y: trkRY });
    var selectionGeometryLength, mpValue;

    if (trkBMP < trkEMP) {
        selectionGeometryLength = lineDistance({ x: trkLX, y: trkLY }, point);
        mpValue = (deltaMile * (selectionGeometryLength / guidGeometryLength)) + trkBMP
    }
    else if (trkBMP > trkEMP) {
        selectionGeometryLength = lineDistance({ x: trkRX, y: trkRY }, point);
        mpValue = (deltaMile * (selectionGeometryLength / guidGeometryLength)) + trkEMP
    }

    return mpValue;
}

function lineDistance(point1, point2) {
    var xs = 0;
    var ys = 0;
    xs = point2.x - point1.x;
    xs = xs * xs;
    ys = point2.y - point1.y;
    ys = ys * ys;
    return Math.sqrt(xs + ys);
}

/**
 * Clears the currentRestrictionLayer then moves the guids on the selectionLayer to the currentRestrictionLayer
 */
function setSelectedGuids(guids) {

    selectionLayer.clear();

    _.each(guids, function (elem) {

        elem.symbol.setColor(Color.blue);
        elem.symbol.width = 8;
        selectionLayer.addElement(elem)
    });
}

/**
 * Clears the currentRestrictionLayer then moves the guids on the selectionLayer to the currentRestrictionLayer
 */
function highlightSelectedGuids(clearLayerFirst) {

    //var guidsToAdd = getNewGuidsIfHighlightApplied();
    var guidsToAdd = selectionLayer.elements;
    if (clearLayerFirst) {
        currentRestrictionLayer.clear();
    }

    _.each(guidsToAdd, function (elem) {

        elem.symbol.setColor(Color.green);
        elem.symbol.width = 8;
        currentRestrictionLayer.addElement(elem)
    });

    selectionLayer.clear();
}

function resetSchematicNoPrompt() {
    selectionLayer.clear();
    deselectionLayer.clear();
    existingRestrictionLayer.clear();
    currentRestrictionLayer.clear();
    excludedGuids = [];
    milePostLayer.clear();

}

/**
 * Centers and zooms the schematic on the selected guids and MPs
 */
function centerAndZoom() {
    if (currentRestrictionLayer.elements.length + milePostLayer.elements.length > 0) {
        centerAndZoomSchematic(_.union(currentRestrictionLayer.elements, milePostLayer.elements))
    }
    else {
        centerAndZoomSchematic(trackLayer.elements)
    }
}

/**
 * Center and zooms the schematic to fit the given elems
 * @param elems
 */
function centerAndZoomSchematic(elems) {
    var extent = SvgUtil.svgElementsExtent(elems);

    /**
     * The extent is a rectangle defined by two points (xmin, ymin) and (xmax, ymax), which surrounds
     * the given elems. By scaling the box we can control where the zoom happens. increasing the max
     * values and decreasing the min values makes the extent bigger, there by zooming out on the selection.
     *
     */
    //    //modify the extent to center the selection and give it some buffer
    if (extent) {
        if (!(currentRestrictionLayer.elements.length + milePostLayer.elements.length > 0)) {
            extent.xmax *= 1.1;
            extent.ymax *= 1.1;

            extent.xmin /= 1.1;
            extent.ymin /= 1.1;
        } else {
            //Based on the zoom level these values are compatible for
            //all the MP ranges
            extent.xmax *= 1.08;
            extent.ymax *= 1.02;

            extent.xmin /= 1.31;
            extent.ymin /= 1.016;
        }
        schematic.setExtent(extent);
    }
}


/**
 * gets the point that this mp is on this guid
 * @param elem
 * @param mp
 * @param trackFields
 * @returns {*}
 */
function interpolateMpOnGuid(elem, mp, trackFields) {

    var attrs = elem.attributes,

        trkLX = attrs[trackFields.TRACK_LX],
        trkLY = attrs[trackFields.TRACK_LY],
        trkRX = attrs[trackFields.TRACK_RX],
        trkRY = attrs[trackFields.TRACK_RY],
        trkBMP = attrs[trackFields.TRACK_BMP],
        trkEMP = attrs[trackFields.TRACK_EMP];

    var px = trkEMP === trkBMP ? trkLX : (((trkRX - trkLX) * (mp - trkBMP)) / (trkEMP - trkBMP)) + trkLX,
        py = trkEMP === trkBMP ? trkLY : (((trkRY - trkLY) * (mp - trkBMP)) / (trkEMP - trkBMP)) + trkLY;

    return new Point({
        x: px,
        y: py
    });
}
